export default "__VITE_ASSET__ca3071d8__"